import React from 'react'
import type { InboxConversationSummary } from './inboxTypes'
import { ConversationSummaryItem } from './ConversationSummaryItem'

interface ConversationListProps {
  conversations: InboxConversationSummary[]
  selectedConversationId: number | null
  onSelect: (id: number) => void
}

export const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  selectedConversationId,
  onSelect
}) => {
  if (conversations.length === 0) {
    return <div className='conversation-list-content'>No conversations yet.</div>
  }

  return (
    <>
      {conversations.map(conversation => (
        <ConversationSummaryItem
          key={conversation.id}
          conversation={conversation}
          isSelected={conversation.id === selectedConversationId}
          onClick={() => onSelect(conversation.id)}
        />
      ))}
    </>
  )
}
